export default __webpack_public_path__ + "static/media/python-intro.2a01ce57.png";